import { Leaderboard } from '../components/shelves/Leaderboard';

export function Insight() {
  return (
    <div className="mx-auto mt-12 mb-16 rounded-lg px-4 lg:px-12">
      <h2 className="mb-4 text-2xl font-bold md:text-3xl">Insight</h2>
      <Leaderboard />
    </div>
  );
}
